import { Component } from '@angular/core';
import { Paths } from '../../../../enums';
import { Router } from '@angular/router';

@Component({
  selector: 'app-premium-access',
  standalone: false,
  templateUrl: './premium-access.component.html',
  styleUrl: './premium-access.component.scss'
})
export class PremiumAccessComponent {
  constructor(private router: Router) { }

  ngOnInit(): void { }

  applyForAdmission() {
    this.router.navigate([`${Paths.coursesCategory}`]);
  }
}
